module.exports = __webpack_public_path__ + "img/speaker-11.72279ebd.jpg";